
















import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { mapGetters } from 'vuex'
import { APP_NS } from '~/store/modules/shared/app/state'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { mapDeps } from '~/plugins/dependency-container/utils'
import ScrollService from '~/services/scroll/ScrollService'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    goToMessagesOnLoad: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      icons: {
        arrowDown: faArrowDown
      },
      showAlert: true
    }
  },
  computed: {
    ...mapGetters(APP_NS, {
      isPlot: 'isPlot'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isPc: 'isPc'
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      isMapVariant: 'isMapVariant'
    }),
    ...mapDeps({
      scrollService: ScrollService
    }),
    miniMessagesElement() {
      try {
        return this.$parent.$el
      } catch {
        this.$logger.captureError(new Error('No parent element found (?)'))
        return null
      }
    },
    scrollElement() {
      if (this.isMapVariant) {
        return document.getElementById('map-classified-view') || window
      }
      return window
    },
    hideAlert() {
      return (this.isPlot && this.isPc) || this.isMapVariant
    }
  },
  mounted() {
    if (this.miniMessagesElement) {
      this.scrollElement.addEventListener('scroll', this.scrollCheck, false)
    }

    if (this.goToMessagesOnLoad) {
      this.scrollToContact()
    }
  },
  destroyed() {
    this.scrollElement.removeEventListener('scroll', this.scrollCheck)
  },
  methods: {
    scrollToContact() {
      const options = {
        easing: 'ease-out',
        offset: -60,
        duration: 500,
        onDone: this.scrollDone()
      }

      if (this.isMapVariant) {
        options.container = this.scrollElement
        options.offset = 60
      }

      this.scrollService.scrollTo(this.$parent.$el, options)
    },
    scrollDone() {
      this.$emit('scrollDone')
    },
    scrollCheck() {
      const messagesTop = this.miniMessagesElement.getBoundingClientRect().top

      if (messagesTop <= window.innerHeight) {
        this.showAlert = false
      } else if (!this.showAlert) {
        this.showAlert = true
      }
    }
  }
})
